import { createFileRoute } from '@tanstack/react-router';
import { DeliveriesRedirectRoute } from './-journeys-redirects';

function DeliveriesRoute() {
  const { workspaceId } = Route.useParams();
  return <DeliveriesRedirectRoute workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/deliveries')({
  component: DeliveriesRoute,
});
